// Public PostHog project key (phc_*); write-only and safe in client/edge code.
export const POSTHOG_API_KEY =
  "phc_dRETsj85vNkKrvQQszEFRBibH5kUF9l7rbjACuKPanZ";
export const POSTHOG_API_HOST = "https://d99bbtllqsaif.cloudfront.net";
export const POSTHOG_CAPTURE_URL = "https://us.i.posthog.com/capture";
